export const FETCH_TRACKS = 'FETCH_TRACKS';

export const EMAIL_SENT = 'EMAIL_SENT';
